import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id D563253F-1895-4DB7-95E9-A0C4C5562D12
 * name pan-right
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pan-right.svg
 * tags
 */
export const PanRightIcon = createSvgIcon(<><path d="M17,8V16L21.5,12L17,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z" /></>, 'PanRightIcon');
export default PanRightIcon